import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function Textsize(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22 21h-9.285v-.976c.432-.033.94-.114 1.525-.244.585-.129.877-.29.877-.481 0-.067-.006-.142-.018-.225a1.61 1.61 0 00-.102-.338l-1.454-3.678H7.659c-.136.342-.287.743-.45 1.201-.165.459-.307.867-.427 1.226-.152.467-.242.805-.27 1.013a3.855 3.855 0 00-.043.438c0 .267.195.494.583.682.388.187 1.035.323 1.94.406V21H2v-.976c.264-.016.563-.06.895-.131.332-.07.594-.169.787-.294.328-.2.606-.446.835-.738.228-.292.418-.638.57-1.038L7.88 10.78C8.813 8.43 9.844 5.835 10.973 3h2.402c1.57 4.02 2.8 7.197 3.688 9.532.889 2.335 1.646 4.27 2.27 5.804.104.25.237.477.397.681a2.59 2.59 0 001.465.882c.296.067.565.109.805.125V21zm-9-7l-2.518-7L8 14h5z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Textsize);
export default ForwardRef;